import React from 'react';
import Navbar from '../components/Navbar';
import { useNavigate, useLocation } from 'react-router-dom';
import { Check, Star, Zap, ShieldCheck } from 'lucide-react';
import './Pricing.css';

function Pricing() {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isFromChat = searchParams.get('source') === 'chat';
    const highlightPlan = searchParams.get('plan');

    React.useEffect(() => {
        if (highlightPlan === 'basic') {
            const basicCard = document.querySelector('.pricing-card:not(.popular)');
            if (basicCard) {
                basicCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
                basicCard.classList.add('highlight-pulse');
            }
        }
    }, [highlightPlan]);

    const plans = [
        {
            name: 'Månedlig plan',
            price: '80 $',
            period: '/mnd',
            description: 'Ideell for månedlige spirituelle samtaler',
            features: [
                '30 guddommelige chatter per måned',
                'Lagre samtalelogg',
                'Tilgang til 700+ vers',
                'Personlig veiledning',
                'Tilgjengelig 24/7'
            ],
            buttonText: 'Start nå',
            isPopular: false,
            color: 'var(--blue-glow)',
            plan_id: 'monthly_30'
        },
        {
            name: 'Premium plan',
            price: '250 $',
            period: '/år',
            description: 'Årlig plan for de som søker den beste opplevelsen',
            features: [
                '360 samtaler per år',
                'Alle funksjoner fra månedlig plan',
                'Prioritert stemmegenerering',
                'Lagre samtalelogg',
                'Prioritert støtte'
            ],
            buttonText: 'Det mest populære valget',
            isPopular: true,
            color: 'var(--accent-glow)',
            plan_id: 'premium_30_yearly'
        }
    ];

    return (
        <div className="pricing-page">
            <Navbar />

            {/* Floating Coupon Notification */}
            <div className="coupon-floating-banner">
                <div className="coupon-content">
                    <div className="coupon-icon">🎁</div>
                    <div className="coupon-text-wrapper">
                        <span className="coupon-label">SPESIALTILBUD</span>
                        <p>Bruk <strong>KRISHNA5</strong> for Basisplan til kun <strong>5 $</strong></p>
                    </div>
                </div>
                <div className="coupon-sparkles"></div>
            </div>

            <div className="pricing-container container">
                <header className="pricing-header">
                    <div className="pricing-badge">
                        <Zap size={14} />
                        <span>PRISER</span>
                    </div>
                    <h1 className="pricing-title">
                        Velg din <span className="gradient-text-animated">sjels vei</span>
                    </h1>
                    <p className="pricing-subtitle">
                        Begynn å investere i din indre fred og spirituelle vekst <br />
                        med planen som passer for deg.
                    </p>

                    {isFromChat && (
                        <div className="chat-upgrade-notice">
                            <div className="notice-icon">✨</div>
                            <div className="notice-text">
                                <strong>Grense nådd:</strong> 
                                Vennligst velg en plan for å fortsette chatten.
                            </div>
                        </div>
                    )}
                </header>

                <div className="pricing-grid">
                    {plans.map((plan, index) => (
                        <div
                            key={index}
                            className={`pricing-card ${plan.isPopular ? 'popular' : ''}`}
                        >
                            {plan.isPopular && <div className="popular-badge">Populær</div>}

                            <div className="plan-name">{plan.name}</div>

                            <div className="plan-price">
                                <span className="currency">{plan.price}</span>
                                <span className="period">{plan.period}</span>
                            </div>

                            <p className="plan-description">{plan.description}</p>

                            <div className="plan-features">
                                {plan.features.map((feature, fIndex) => (
                                    <div key={fIndex} className="feature-item">
                                        <div className="check-icon">
                                            <Check size={16} />
                                        </div>
                                        <span>{feature}</span>
                                    </div>
                                ))}
                            </div>

                            <button
                                className={`plan-button ${plan.isPopular ? 'btn-premium-primary' : 'btn-premium-secondary'}`}
                                onClick={() => navigate('/checkout', { state: { plan } })}
                            >
                                {plan.buttonText}
                            </button>
                        </div>
                    ))}
                </div>

                <div className="pricing-trust">
                    <div className="trust-item">
                        <ShieldCheck size={24} />
                        <span>Sikre betalinger</span>
                    </div>
                    <div className="trust-item">
                        <Star size={24} />
                        <span>100% fornøyd</span>
                    </div>
                    <div className="trust-item">
                        <Zap size={24} />
                        <span>Umiddelbar tilgang</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Pricing;
